import { useFocusEffect } from '@react-navigation/native';
import { useCallback, useState } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import localforage from 'localforage';
import { IS_WEB } from '@/utils/platform';

export const useNavigationHighlight = ({
  sessionKey,
  maxCount,
  enabled,
}: {
  sessionKey: string;
  maxCount: number;
  enabled: boolean;
}) => {
  const [shouldHighlight, setShouldHighlight] = useState(false);

  const onClickIncrement = async () => {
    const raw = IS_WEB
      ? await localforage.getItem(sessionKey)
      : await AsyncStorage.getItem(sessionKey);
    const count = Number(raw ?? 0);

    if (count < maxCount) {
      if (IS_WEB) {
        await localforage.setItem(sessionKey, String(count + 1));
      } else {
        await AsyncStorage.setItem(sessionKey, String(count + 1));
      }
    }
  };

  useFocusEffect(
    useCallback(() => {
      if (!enabled) {
        setShouldHighlight(false);
        return;
      }

      const checkAndConsume = async () => {
        const raw = IS_WEB
          ? await localforage.getItem(sessionKey)
          : await AsyncStorage.getItem(sessionKey);
        const count = Number(raw ?? 0);

        if (count < maxCount) {
          setShouldHighlight(true);
        } else {
          setShouldHighlight(false);
        }
      };

      checkAndConsume();
    }, [sessionKey, maxCount, enabled]),
  );

  return { onClickIncrement, shouldHighlight };
};
